import React from 'react';
import PropTypes from 'prop-types';
import ImageCropped from '../../image_cropped';
import PlanBadge from './attach_entity/PlanBadge';

function AttachedExistingEntity({
                                  firstName,
                                  isPaid,
                                  isViewersOwnProfile,
                                  name,
                                  profileImageUrl,
                                  promoEntityId,
                                  removeCallback,
                                  subheading,
                                }) {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      removeCallback(promoEntityId);
    }
  };

  return (
    <div className="attached-entity-card bg-white mt-2 me-2 d-inline-flex flex-row align-items-center">
      <div className={`d-flex ${isPaid ? 'pro-avatar-ring' : ''}`}>
        <ImageCropped roundedCircle src={profileImageUrl} alt={name} size={43} fallbackToInitials />
      </div>
      <div className="d-flex flex-column align-items-start justify-content-start">
        <div className="d-flex align-items-center">
          <strong>{name}</strong>
          <PlanBadge
            isPaid={isPaid}
            isViewersOwnProfile={isViewersOwnProfile}
            firstName={firstName}
            className="ms-2"
          />
        </div>
        {subheading && <div className="small text-secondary">{subheading}</div>}
      </div>
      {removeCallback && (
        <div
          className="attached-entity-remove btn p-2 rounded-2 text-body d-flex align-items-center justify-content-center"
          id="test-remove"
          onClick={() => removeCallback(promoEntityId)}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex="0"
        >
          <i className="fa-solid fa-xmark" />
        </div>
      )}
    </div>
  );
}

AttachedExistingEntity.propTypes = {
  firstName: PropTypes.string,
  isPaid: PropTypes.bool,
  isViewersOwnProfile: PropTypes.bool,
  name: PropTypes.string.isRequired,
  profileImageUrl: PropTypes.string,
  promoEntityId: PropTypes.string.isRequired,
  removeCallback: PropTypes.func.isRequired,
  subheading: PropTypes.string,
};

AttachedExistingEntity.defaultProps = {
  firstName: undefined,
  isPaid: undefined,
  isViewersOwnProfile: false,
  profileImageUrl: undefined,
  subheading: undefined,
};

export default AttachedExistingEntity;
